/* JUST FLOW — flow engine
   1. Scroll reveals with per-section stagger
   2. Hero parallax (Golden Hour) — transform-only, rAF-driven
   3. The signature move: on the homepage the whole palette rides the
      scrollbar from Golden Hour (day) to After Dark (night). Anchors:
      [data-jf-dusk-start] and [data-jf-dusk-end] sections.            */
(function () {
  var root = document.documentElement;
  root.classList.add('jf-js');

  var main = document.getElementById('MainContent');
  var template = (main && main.dataset && main.dataset.template) || '';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (template.indexOf('page.after-dark') !== -1) {
    root.classList.add('jf-dark', 'jf-dusk');
  }

  /* ----- reveals ----- */
  var reveals = Array.prototype.slice.call(document.querySelectorAll('.jf-reveal'));
  var groups = new Map();
  reveals.forEach(function (el) {
    var p = el.closest('.shopify-section') || document.body;
    var i = groups.get(p) || 0;
    groups.set(p, i + 1);
    el.style.setProperty('--d', (i * 85) + 'ms');
  });
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  /* ----- hero parallax (day hero only) ----- */
  var heroImg = document.querySelector('.jf-hero__media img');
  if (heroImg && !reduce && !root.classList.contains('jf-dark')) {
    var cur = -1;
    var loop = function () {
      var t = Math.min(window.scrollY * 0.07, 60);
      if (t !== cur) {
        cur = t;
        heroImg.style.setProperty('--py', t.toFixed(2));
      }
      window.requestAnimationFrame(loop);
    };
    window.requestAnimationFrame(loop);
  }

  /* ----- day -> dusk scroll drive (homepage only) ----- */
  if (template !== 'index' || root.classList.contains('jf-dark')) return;
  root.classList.add('jf-flow');

  var STOPS = {
    '--jf-bg':       [[242, 237, 227], [20, 18, 15]],
    '--jf-bg2':      [[233, 226, 210], [28, 25, 21]],
    '--jf-card':     [[252, 250, 245], [28, 25, 21]],
    '--jf-ph':       [[247, 244, 236], [38, 33, 25]],
    '--jf-ink':      [[38, 35, 29],    [237, 230, 214]],
    '--jf-soft':     [[87, 80, 63],    [151, 144, 127]],
    '--jf-accent':   [[176, 144, 98],  [194, 166, 120]],
    '--jf-accent-2': [[150, 117, 74],  [194, 166, 120]],
    '--jf-hair':     [[221, 213, 194], [44, 40, 32]]
  };

  /* 🔴🔴 TWO-PHASE PALETTE — READ BEFORE "SMOOTHING" IT BACK.

     THE BUG IT FIXES: the original code crossfaded background AND text on
     the SAME curve, so they passed through each other. Measured on the real
     stops, at the midpoint background was rgb(131,128,121) and ink
     rgb(138,132,122) — CONTRAST 1.06, i.e. invisible, failing WCAG AA across
     roughly a third of the page. Jay caught it on the jf-story headings.

     WHY NO TEXT COLOUR FIXES IT ALONE: the background passes through
     mid-grey. Against mid-grey, black scores 3.98 and white 4.27 — nothing
     reaches 4.5. The hostile BACKGROUND is the problem, not the text.

     A FAILED FIX IS ON RECORD SO IT IS NOT RETRIED: holding the ink dark and
     ramping it over an 0.08 window scored 1.00 in a 1000-sample sweep, WORSE
     than doing nothing, because the ramp drags the ink through mid-grey at
     exactly the moment the background is also mid-grey. A coarse 5-point
     search had said 3.51 and it shipped on that basis before the fine sweep
     caught it. SAMPLE FINELY OR DO NOT TRUST THE NUMBER.

     THE DESIGN: the background never sits in the hostile mid-range.
       DAY  (p < 0.5): fades cream -> LIGHT_FLOOR. Text stays DARK.
       NIGHT(p >= 0.5): starts at DARK_CEIL -> near-black. Text is LIGHT.
     One switch at the midpoint, eased over 450ms by assets/jf-dusk-ease.css
     so it plays as a quick fade rather than a single-frame cut.

     🔑 THE JUMP (DARK_CEIL - LIGHT_FLOOR) IS THE ONLY TUNING KNOB, AND IT IS
     A DIRECT TRADE AGAINST READABILITY. Solved numerically — the smallest
     jump that clears each contrast target:
         jump 0.37  worst contrast 6.09   (first version; Jay: "abrupt")
         jump 0.16  worst contrast 4.50   <- CURRENT, smallest that clears AA
         jump 0.10  worst contrast 4.09
         jump 0.02  worst contrast 3.59   (near-seamless, below the standard)
     Jay asked for a softer fade on 2026-08-10 after seeing it live;
     0.37 -> 0.16 more than halves the visible step and still clears 4.5.
     DO NOT lower these further without re-running the sweep — below 0.16 the
     page stops meeting the accessibility standard.                        */
  var LIGHT_FLOOR = 0.46;  /* lightest the day side is allowed to get */
  var DARK_CEIL   = 0.62;  /* darkest the night side starts at        */
  var TEXT_KEYS = { '--jf-ink': 1, '--jf-soft': 1, '--jf-accent-2': 1 };

  var startEl = document.querySelector('[data-jf-dusk-start]');
  var endEl = document.querySelector('[data-jf-dusk-end]');

  function docTop(el) {
    return el.getBoundingClientRect().top + window.scrollY;
  }

  var lastP = -1;
  function applyPalette(p) {
    if (Math.abs(p - lastP) < 0.004) return;
    lastP = p;

    var night = p >= 0.5;
    var half = night ? (p - 0.5) / 0.5 : p / 0.5;
    var bgT = night
      ? DARK_CEIL + (1 - DARK_CEIL) * half
      : LIGHT_FLOOR * half;
    var textT = night ? 1 : 0;

    for (var name in STOPS) {
      var a = STOPS[name][0];
      var b = STOPS[name][1];
      var t = TEXT_KEYS[name] ? textT : bgT;
      root.style.setProperty(name, 'rgb(' +
        Math.round(a[0] + (b[0] - a[0]) * t) + ',' +
        Math.round(a[1] + (b[1] - a[1]) * t) + ',' +
        Math.round(a[2] + (b[2] - a[2]) * t) + ')');
    }
    root.style.setProperty('--jf-grain', (bgT * 0.5).toFixed(3));
    root.classList.toggle('jf-dusk', night);
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      var vh = window.innerHeight;
      var y = window.scrollY + vh * 0.6;
      var y0 = startEl ? docTop(startEl) : vh;
      var y1 = endEl ? docTop(endEl) + endEl.offsetHeight * 0.4
                     : document.body.scrollHeight - vh;
      var p = (y - y0) / Math.max(1, y1 - y0);
      p = Math.max(0, Math.min(1, p));
      /* ease-in-out so day lingers, dusk arrives, night settles */
      p = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      applyPalette(p);
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();
})();
